import { get, post, deleteApi, put } from "../../api/index";

import { API_ENDPOINTS, FIELDS } from "../../constants";

const { APIS } = API_ENDPOINTS;
const { DATA_SOURCES } = FIELDS;
export const fetchAllFormFields = templateId =>
  new Promise((resolve, reject) => {
    let fetchURL = `${APIS.FETCH_FIELDS_LIST}`;
    if (templateId) {
      fetchURL = `${fetchURL}?template_id=${templateId}`;
    }
    get(`${fetchURL}`)
      .then(res => {
        resolve(res.fields);
      })
      .catch(error => {
        reject(error);
      });
  });

export const startDataSourceSync = objectDetails =>
  new Promise((resolve, reject) => {
    post(`${APIS.START_FIELD_SYNC}`, objectDetails)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const fetchDSObjects = dsName =>
  new Promise((resolve, reject) => {
    const dataSource = DATA_SOURCES.find(source => source.name === dsName);
    get(`${APIS.FETCH_CRM_OBJECTS}/${dataSource.urlRef}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getSFObjectSchema = (dsName, objectID) =>
  new Promise((resolve, reject) => {
    const dataSource = DATA_SOURCES.find(source => source.name === dsName);
    get(`${APIS.DP_OBJECT_FIELDS}/${dataSource.urlRef}/${objectID}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const fetchFieldMapping = (templateID, dsName) =>
  new Promise((resolve, reject) => {
    let fieldMappingURL = templateID
      ? `${APIS.FETCH_TEMPLATE_FIELDS_MAPPING}/${templateID}`
      : `${APIS.FETCH_ORG_FIELDS_MAPPING}`;
    if (dsName) {
      const dataSource = DATA_SOURCES.find(source => source.name === dsName);
      fieldMappingURL = `${fieldMappingURL}?crm=${dataSource.urlRef}`;
    }
    get(fieldMappingURL)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const saveFieldMapping = dataMap =>
  new Promise((resolve, reject) => {
    post(`${APIS.DP_MAPPING}`, dataMap)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const deleteFieldMapping = mappingID =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.DP_MAPPING}/${mappingID}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const createBulkDocumentsService = (templateID, creationDeatils) =>
  new Promise((resolve, reject) => {
    post(`${APIS.BULK_DOC_CREATION}/${templateID}`, creationDeatils)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const createTriggerService = creationDeatils =>
  new Promise((resolve, reject) => {
    post(`${APIS.DATASTUDIO_TRIGGER}`, creationDeatils)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateTriggerService = (updateTriggerPayload, triggerId) =>
  new Promise((resolve, reject) => {
    put(`${APIS.DATASTUDIO_TRIGGER}/${triggerId}`, updateTriggerPayload)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getTriggerDetailsService = templateId =>
  new Promise((resolve, reject) => {
    get(`${APIS.DATASTUDIO_TRIGGER}?template_id=${templateId}`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getTriggerPackageService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.DATASTUDIO_TRIGGER}/package`)
      .then(res => {
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
